import { render, staticRenderFns } from "./filePreview.vue?vue&type=template&id=b152fdf0&scoped=true"
import script from "./filePreview.vue?vue&type=script&lang=js"
export * from "./filePreview.vue?vue&type=script&lang=js"
import style0 from "./filePreview.vue?vue&type=style&index=0&id=b152fdf0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b152fdf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b152fdf0')) {
      api.createRecord('b152fdf0', component.options)
    } else {
      api.reload('b152fdf0', component.options)
    }
    module.hot.accept("./filePreview.vue?vue&type=template&id=b152fdf0&scoped=true", function () {
      api.rerender('b152fdf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/accountsPayable/cmp/filePreview.vue"
export default component.exports